var exports = {
  "p_": "list__EUEGG6",
  "_Q": "iconLink__TFAvFj",
  "Kk": "icon__2iWCUd",
};

module.exports = exports;
